<div class="flex items-center justify-between px-6 py-4 border-b">
  <h2 class="text-lg font-semibold text-gray-800">
    {{ modalTitle }}
  </h2>
  <button
    type="button"
    class="text-gray-700 text-2xl font-bold"
    aria-label="Close"
    (click)="closeModal.emit(true)"
  >
    ×
  </button>
</div>

<div class="px-6 py-6 border-b">
  <h2 class="my-4 text-xl text-gray-900 font-bold">
    {{ confirmationText }}
  </h2>
</div>

<div class="flex justify-end gap-4 px-6 py-4">
  <button
    type="button"
    class="py-2 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition"
    (click)="closeModal.emit(true)"
  >
    No
  </button>
  <button
    type="submit"
    class="py-2 px-4 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
    (click)="confirm.emit(true)"
  >
    Yes
  </button>
</div>
